import { FormContextProvider } from 'shared-widget-components/src/providers/FormContextProvider';
import { validationSchema } from './validationSchema';

interface SubscribePreviewWrapperProps {
  children: JSX.Element;
}

/**
 * SubscribePreviewWrapper component
 * this component is responsible for providing the context for the subscribe widget
 * @param children - the children of the component
 * @returns SubscribePreviewWrapper component
 */
export const SubscribePreviewWrapper = ({ children }: SubscribePreviewWrapperProps) => {
  return <FormContextProvider validationSchema={validationSchema}>{children}</FormContextProvider>;
};
